import { Alert, Button, Form, Image, Input, InputNumber, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { productTabConfig } from '../ProductsTab'
import { useDispatch, useSelector } from 'react-redux';
import { DELETE, GET, POST } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher, processReq } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addProduct, setProduct, updateProduct } from '../../../store/slices/productSlice';
import ImageGallery from '../../../components/ImageGallery';
import { ArrowRightOutlined, SearchOutlined } from '@ant-design/icons';
import Barcode from 'react-barcode';
import { getProductBarCode } from '../../../utils/formatters';
import LexicalEditor from '../../../components/editor/LexicalEditor';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

function AddProduct({ onSwitchTab, tabProps = {} }) {
  const product = useSelector(state => state.productSlice.product);
  const state = useSelector(state => state.productSlice);
  const categoryDataFetcher = useSWR({ method: GET, url: API_ROUTE + '/categories' }, fetcher);
  const categories = categoryDataFetcher.isLoading ? [] : categoryDataFetcher.data.data;
  const [form] = Form.useForm();
  const [imageForm] = Form.useForm();
  const dispatch = useDispatch();
  const imagesData = useSWR({ method: GET, url: API_ROUTE + '/upload/' }, fetcher);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [productContent, setProductContent] = useState(product.content);

  useEffect(() => {
    loadValues();
  }, [product]);

  const loadValues = () => {
    if (product.id) {
      form.setFieldsValue(product);
      setProductContent(product.content);
    } else {
      form.resetFields();
    }
  }

  const saveProduct = (data) => {
    if (product.id) {
      dispatch(updateProduct({ productId: product.id, productData: data }));
    } else {
      dispatch(addProduct({ productData: data }));
    }
    setErrorMessage(null);
  }

  const saveProductImage = async (data) => {
    await processReq(POST, API_ROUTE + '/productImage/', { productId: product.id, imageUrl: data.imageUrl });
    const saved = await processReq(GET, API_ROUTE + '/products/' + product.id);
    dispatch(setProduct(saved.data));
    imageForm.resetFields();
  }

  const deleteProductImage = async (data) => {
    await processReq(DELETE, API_ROUTE + '/productImage/' + data.id);
    const saved = await processReq(GET, API_ROUTE + '/products/' + product.id);
    dispatch(setProduct(saved.data));
  }

  const manageInventory = (data) => {
    dispatch(setProduct(data))
    onSwitchTab(productTabConfig.PRODUCT_INVENTORY, data);
  }

  return (
    <div>
      <div className='text-center py-2 mb-2 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{product.id ? "Update Product" : "Add New Product"}</div>
      <div className='text-right'>{product.id && <Button className='mb-5' onClick={() => manageInventory(product)}>Show Inventory for {product.name} <ArrowRightOutlined style={{ fontSize: 20 }} /></Button>}</div>
      {/* <div>{product.id && (<div className='text-center'><Barcode value={getProductBarCode(product.id)} className='m-auto' /></div>)}</div> */}
      <Form
        disabled={state.loading.saving}
        form={form}
        layout='verticle'
        {...formItemLayout}
        style={{
          maxWidth: 600,
          margin: 'auto'
        }}
        onFinish={saveProduct}
        onFinishFailed={(message) => setErrorMessage(message.errorFields[0].errors[0])}
      >
        <Form.Item
          label="Product Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Enter product name  ',
            },
          ]}
        >
          <Input placeholder='Name of the product' />
        </Form.Item>
        <Form.Item
          label="SKU"
          name="sku"
          rules={[
            {
              required: true,
              message: 'Enter product sku  ',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Product Description"
          name="description"
          rules={[
            {
              required: true,
              message: 'Enter product description  ',
            },
          ]}
        >
          <Input.TextArea rows={12} placeholder='Description' />
        </Form.Item>
        <Form.Item
          label="Product Ingredients"
          name="ingredients"
          rules={[
            {
              required: true,
              message: 'Enter product ingredients  ',
            },
          ]}
        >
          <Input.TextArea rows={12} placeholder='Ingredients' />
        </Form.Item>
        <Form.Item
          label="Product Benefits"
          name="productBenefits"
          rules={[
            {
              required: true,
              message: 'Enter product benefits  ',
            },
          ]}
        >
          <Input.TextArea rows={12} placeholder='Benefits' />
        </Form.Item>
        <Form.Item
          label="More Content"
          name="content"
          rules={[
            {
              required: true,
              message: 'Enter more content  ',
            },
          ]}
        >
          <LexicalEditor
              initialJSON={productContent}
              onChange={json => setProductContent(json)}
              placeholder="Write your page content…"
          />
        </Form.Item>
        {/* <Form.Item
          label="Price"
          name="price"
          hidden
          rules={[
            {
              required: false,
              message: 'Enter product price  ',
            },
          ]}
        >
          <InputNumber defaultValue={0} value={0} placeholder='Enter price' />
        </Form.Item> */}

        <div className='text-center'>
          {product.id ? <Image src={product.imageUrl} style={{ objectFit: 'cover' }} width={100} height={100} alt={product.name} className='h-52 m-auto pb-3' /> : <div>Search and copy paste product main image link</div>}  <br />
          <Button type='text' onClick={() => setIsModalOpen(true)}><SearchOutlined /></Button>
        </div>
        <Form.Item
          label="Product Image"
          name="imageUrl"
          rules={[
            {
              required: true,
              message: 'Enter the main product image url  ',
            },
          ]}
        >
          <Input placeholder='Image url of the product' />
        </Form.Item>

        <Form.Item
          label="Product Category"
          name="categoryId"
          rules={[
            {
              required: true,
              message: 'Select Category',
            },
          ]}
        >
          <Select
            placeholder="Select Category"
          >
            {categories.map((cat) => {
              return (
                <Select.Option key={cat.id} value={cat.id}>{cat.name}</Select.Option>
              )
            })}
          </Select>
        </Form.Item>
        <div className='text-lg border-b mb-4'>Pricing</div>
        {/* <Form.Item
          label="Discount Amount"
          name="discountAmount"
          rules={[
            {
              required: false,
              message: 'Enter discount amount in LKR',
            },
          ]}
        >
          <InputNumber defaultValue={0} placeholder='Enter discount amount in LKR' />
        </Form.Item> */}
        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
          <div className='pb-1'>{errorMessage && <Alert message={errorMessage} type='error' />}</div>
          <div className='flex justify-between'>
            <div>{product.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
            <div className='flex'>
              <Button danger type='text' htmlType='reset'>Clear</Button>
              <Button type='primary' htmlType='submit' loading={state.loading.saving}>{product.id ? "Update" : "Save"}</Button>
            </div>
          </div>
        </Form.Item>
      </Form>

      {product.id && (
        <div className='m-auto' style={{ maxWidth: 300 }}>
          <div>
            <Form onFinish={saveProductImage} form={imageForm} style={{

              margin: 'auto',
              layout: 'horizontal',
              display: 'flex',
              justifyContent: 'space-between',
            }}>
              <Form.Item name={'imageUrl'} style={{ width: '100%' }} rules={[
                {
                  required: true,
                  message: 'Enter an image url for the product',
                },
              ]}>
                <Input placeholder='Add an image url for the product' />
              </Form.Item>
              <Button htmlType='submit'>Add</Button>
              <Button type='text' onClick={() => setIsModalOpen(true)}><SearchOutlined /></Button>
            </Form>
          </div>

          <div className='grid grid-cols-2 gap-2'>
            {product?.images?.map((img, index) => {
              return (
                <div key={index} className='border text-center'>
                  <img src={img.imageUrl} alt={product.name} className={'h-2/3 m-auto'} />
                  <Button danger type='text' onClick={() => deleteProductImage(img)}>Delete</Button>
                </div>
              )
            })}
          </div>
        </div>
      )}

      <Modal
        title={`Search Images`}
        centered
        maskClosable={false}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        styles={{ body: { maxHeight: "600px", overflowY: "auto", paddingRight: 5 } }}
      >
        <div className='w-full'><ImageGallery imagesData={imagesData} /></div>
      </Modal>
    </div>
  )
}

export default AddProduct